<template>
    <div>
        <div class="form-group col-12">
            <label>Pdf</label>
            <media-chooser :value="pdf" type="pdf" @input="onPdfChange" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            pdf: {},
            id: Math.random()
                .toString(36)
                .substring(2, 15)
                .match(/[a-zA-Z]+/g)
                .join('')
        };
    },

    mounted() {
        this.pdf = { ...this.value };
    },

    methods: {
        onPdfChange(pdf) {
            this.pdf = { ...pdf };

            this.$emit('input', this.pdf);
        }
    }
};
</script>
